export default {
  setSubscriptions: (state, subscriptions) => {
    state.subscriptions = subscriptions;
  },

  setSubscription: (state, subscription) => {
    state.subscription = subscription;
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
